import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '../Grid/index.js';
import { Content, PageBase, Progress, TopNav } from '../index.js';
import Create from './steps/Create.js';
import Economy from './steps/Economy.js';
export var CaseCreationStep;
(function (CaseCreationStep) {
    CaseCreationStep["Create"] = "create";
    CaseCreationStep["Economy"] = "economy";
    CaseCreationStep["Parties"] = "parties";
})(CaseCreationStep || (CaseCreationStep = {}));
const states = [
    CaseCreationStep.Create,
    CaseCreationStep.Economy,
    CaseCreationStep.Parties,
];
const isReached = (step, reachedStep) => {
    const index = states.findIndex((_s) => _s === step);
    const activeIndex = states.findIndex((_s) => _s === reachedStep);
    return index <= activeIndex;
};
const CaseCreator = (props) => {
    const lang = useSelector((s) => s.lang);
    const state = props.state || { type: CaseCreationStep.Create };
    const step = state.type;
    const caseId = step !== CaseCreationStep.Create ? state.caseId : null;
    return (React.createElement("div", null,
        React.createElement(TopNav, null),
        React.createElement(Content, { maxWidth: "1100px" },
            React.createElement(PageBase, null,
                React.createElement(Row, null,
                    React.createElement(Col, { width: "3", style: { position: 'sticky' } },
                        React.createElement("br", null),
                        React.createElement("br", null),
                        React.createElement(Progress, { items: [
                                {
                                    active: isReached(CaseCreationStep.Create, step),
                                    title: lang.cases.newCaseCreate,
                                },
                                {
                                    active: isReached(CaseCreationStep.Economy, step),
                                    title: lang.cases.newCaseEconomy,
                                    link: props.genLink(caseId, CaseCreationStep.Economy),
                                },
                                {
                                    active: false,
                                    title: lang.cases.newCaseDone,
                                },
                            ] })),
                    React.createElement(Col, { width: "9" }, (() => {
                        switch (step) {
                            case CaseCreationStep.Create:
                                return (React.createElement(Create, { genLink: (caseId, step) => props.genLink(caseId, step) }));
                            case CaseCreationStep.Economy:
                                return (React.createElement(Economy, { caseId: state.caseId, genLink: (caseId, step) => props.genLink(caseId, step) }));
                            default:
                                return null;
                        }
                    })()))))));
};
export default CaseCreator;
//# sourceMappingURL=CaseCreator.js.map